var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title_div"},[_c('div',{staticClass:"title_h3"},[_vm._v(_vm._s(_vm.forms.h1))]),_c('div',{staticClass:"title_p"},[_vm._v(_vm._s(_vm.forms.h2))])])}
var staticRenderFns = []

export { render, staticRenderFns }